module.exports = __webpack_public_path__ + "img/banner-1.18afe5bc.jpg";